<app-pcbread-crumb [data]="'warehouse,Warehouse'"></app-pcbread-crumb>

<div class="content-wrapper">
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="row">
      <div class="col-12">
        <div
          class="card mb-4 stock-card animate__animated animate__backInDown"
          #firstStep
        >
          <div class="card-body">
            <div class="row row-main-stock">
              <div
                class="col-12 col-lg-3 col-md-4 fix-buttons"
                *ngFor="let stock of stocks"
              >
                <div class="stock-box p-0 m-2">
                  <button
                    type="button"
                    class="stock-botton"
                    (click)="gotoDetail(stock)"
                    *ngIf="!stock.isEditable"
                    [ngClass]="{
                      'selected-shelf':
                        stock.stockTypeId ===
                        'b366ec84-28d6-4c20-a2ea-6480f5b8ef10',
                      'selected-stock':
                        stock.stockTypeId ===
                        '6832cb48-e9c1-41f4-b648-ba37d8a62d1a'
                    }"
                  >
                    <div class="row selected-type">
                      <p>{{ stock.title }}</p>
                    </div>
                  </button>
                  <div class="action-box mx-2" *ngIf="!stock.isEditable">
                    <button
                      type="button"
                      class="tree-button-edit p-0 mx-1"
                      (click)="openEdit(stock)"
                    >
                      <i class="fa-solid fa-pencil"></i>
                    </button>
                  </div>
                  <div class="add-box p-0 m-2" *ngIf="stock.isEditable">
                    <div class="new-item position-relative m-2 mb-0">
                      <label class="form-label">
                        {{ "StockName" | translate }}
                      </label>
                      <p class="validation-alert-pc-modal">
                        {{ newItem.nameMessage }}
                      </p>
                      <input
                        class="form-control mb-2"
                        type="text"
                        [(ngModel)]="stock.title"
                        [ngClass]="{
                          'is-invalid':
                            newItem.nameMessage != undefined &&
                            newItem.nameMessage != ''
                        }"
                      />
                    </div>
                    <div class="new-item position-relative m-2 mt-0">
                      <label class="form-label">
                        {{ "StockType" | translate }}
                      </label>
                      <p class="validation-alert-pc-modal">
                        {{ newItem.typeMessage }}
                      </p>
                      <select
                        class="form-select"
                        [(ngModel)]="stock.stockTypeId"
                        [ngClass]="{
                          'is-invalid':
                            newItem.typeMessage != undefined &&
                            newItem.typeMessage != ''
                        }"
                      >
                        <option disabled>{{ "Select" | translate }}</option>
                        <option
                          *ngFor="let stockType of stockTypes"
                          [value]="stockType.id"
                        >
                          {{ stockType.persianName }}
                        </option>
                      </select>
                    </div>
                    <div class="d-flex justify-content-around">
                      <button
                        type="button"
                        class="btn btn-primary add-stock mb-2"
                        (click)="edit(stock)"
                      >
                        {{ "Save" | translate }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-label-secondary mb-2"
                        (click)="stock.isEditable = false"
                      >
                        {{ "Cancel" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-3 col-md-4 fix-buttons">
                <div class="add-box p-0 m-2">
                  <button
                    type="button"
                    class="btn-add"
                    *ngIf="activeAdd"
                    (click)="activeAdd = false"
                  >
                    <i class="fa fa-plus"></i>
                    {{ "Add" | translate }}
                  </button>
                  <div class="new-item position-relative m-2 mb-0">
                    <div class="display-status">
                      <label class="form-label">
                        {{ "StockName" | translate }}
                      </label>
                      <button
                        type="button"
                        class="delete-campain"
                        (click)="activeAdd = true"
                      >
                        <i class="fa-solid fa-reply"></i>
                      </button>
                    </div>
                    <p
                      class="validation-alert-pc-modal new-position-validation"
                    >
                      {{ newItem.nameMessage }}
                    </p>
                    <input
                      class="form-control mb-2"
                      type="text"
                      [ngClass]="{
                        'is-invalid':
                          newItem.nameMessage != undefined &&
                          newItem.nameMessage != ''
                      }"
                      [(ngModel)]="newItem.name"
                    />
                  </div>
                  <div class="new-item position-relative m-2 mt-0">
                    <label class="form-label">
                      {{ "StockType" | translate }}
                    </label>
                    <select
                      class="form-select"
                      [(ngModel)]="newItem.type"
                      [ngClass]="{
                        'is-invalid':
                          newItem.typeMessage != undefined &&
                          newItem.typeMessage != ''
                      }"
                    >
                      <option disabled>{{ "Select..." | translate }}</option>
                      <option
                        *ngFor="let stockType of stockTypes"
                        [value]="stockType.id"
                      >
                        {{ stockType.persianName }}
                      </option>
                    </select>
                    <p class="validation-alert-pc-modal">
                      {{ newItem.typeMessage }}
                    </p>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary add-stock mb-2"
                    (click)="add()"
                  >
                    {{ "Add" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          #secondStep
          class="card p-2 position-relative animate__animated hidden-item"
        >
          <!-- *ngIf="level == 2" -->
          <app-pctable-action
            [data]="action"
            [header]="fields"
            (parentAction)="parentAction($event)"
          >
          </app-pctable-action>

          <app-pctable
            [data]="data"
            [entityField]="fields"
            (parentAction)="parentAction($event)"
          >
          </app-pctable>

          <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
          </app-pcpaging>

          <app-loading-panel *ngIf="loading"> </app-loading-panel>
        </div>
      </div>
    </div>
  </div>
</div>

<app-pcsetting-modal
  (parentAction)="parentAction($event)"
  [fields]="fields"
>
</app-pcsetting-modal>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<!-- 
<ng-template #modalContent let-modal>
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">ویرایش انبار</h6>
    <button
      type="button"
      class="btn-close close-modal-button text-reset"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body mx-0 flex-grow-0">
    <form class="add-new-user pt-0" autofil autocomplete="false">
      <div class="row modal-body-form">
        <div class="col-6 mb-3">
          <div class="edit-form">
            <label class="form-label">
              {{ "count" | translate }}
            </label>
                     <input
              type="number"
              class="form-control"
              [(ngModel)]="thisValue.count"
              [ngModelOptions]="{ standalone: true }"
              [attr.placeholder]="'count' | translate"
            />
          </div>
        </div>
      </div>

      <app-loading-panel *ngIf="!fields"></app-loading-panel>
    </form>
  </div>
  <div class="modal-footer border-top p-3">
    <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit">
      {{ "Submit" | translate }}
    </button>
    <button
      type="reset"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
</ng-template>
 -->
